import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import API_URL from "../Config"; 
import axios from "axios";
import dayjs from "dayjs";

const LiveStreamingPage = () => {
  const location = useLocation();
  const {
    videoUrl,
    streamTitle,
    streamId,
    startOffset = 0,
    autoStart = false,
  } = location.state || {};

  const [streamData, setStreamData] = useState(null);
  const videoRef = useRef();

  // Fetch stream details
  useEffect(() => {
    if (streamId) {
      axios
        .get(`${API_URL}/api/streams/${streamId}`)
        .then((res) => setStreamData(res.data))
        .catch((err) => console.error("Error fetching stream data:", err));
    }
  }, [streamId]);

  // Handle autoplay if live
  useEffect(() => {
    if (!videoUrl || !streamData || !videoRef.current) return;

    const video = videoRef.current;
    const now = dayjs();
    const scheduleStart = dayjs(streamData.scheduleStart);
    const scheduleEnd = dayjs(streamData.scheduleEnd);

    // Only auto-play if currently live
    if (now.isAfter(scheduleStart) && now.isBefore(scheduleEnd)) {
      const offsetSeconds = now.diff(scheduleStart, "second");
      video.currentTime = offsetSeconds;
      video.play().catch((err) => console.log("Autoplay blocked:", err));
    }
  }, [videoUrl, streamData]);

  if (!streamData) return <p>Loading stream data...</p>;

  return (
    <div className="marquee-container">
      <div className="container3 mt-10">
        <ol className="breadcrumb mb-4 d-flex my-0">
          <li className="breadcrumb-item text-white">Live Streaming</li>
        </ol>

        <div className="outer-container">
          <div className="table-container p-4 d-flex flex-wrap justify-content-between gap-4">

            {/* Video Player */}
            <div
              className="video-player"
              style={{
                flex: "1 1 60%",
                minWidth: "300px",
                height: "400px",
                backgroundColor: "#2b2b2b",
                borderRadius: "12px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* {videoUrl ? (
                
                <video
                  ref={videoRef}
                  src={videoUrl}
                  controls
                  muted
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "12px",
                    backgroundColor: "#000",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <p style={{ color: "#fff" }}>No video selected</p>
              )} */}
              {videoUrl ? (
  <div
    style={{
      position: "relative",
      width: "100%",
      height: "100%",
    }}
  >
    {/* LIVE Badge */}
    {dayjs().isAfter(dayjs(streamData.scheduleStart)) &&
      dayjs().isBefore(dayjs(streamData.scheduleEnd)) && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            backgroundColor: "#28a745", // green
            color: "white",
            fontWeight: "bold",
            padding: "6px 12px",
            borderRadius: "8px",
            zIndex: 10,
            fontSize: "14px",
          }}
        >
          🔴 LIVE
        </div>
      )}

    {/* Video */}
    <video
      ref={videoRef}
      src={videoUrl}
      controls
      muted
      style={{
        width: "100%",
        height: "100%",
        borderRadius: "12px",
        backgroundColor: "#000",
        objectFit: "contain",
      }}
    />
  </div>
) : (
  <p style={{ color: "#fff" }}>No video selected</p>
)}

            </div>

            {/* Stream Info */}
            <div
              style={{
                backgroundColor: "#F5F5F5",
                color: "#2B2A52",
                flex: "1 1 35%",
                minWidth: "280px",
                height: "400px",
                borderRadius: "15px",
                padding: "25px",
                border: "1px solid #ccc",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                whiteSpace: "normal",
                justifyContent: "center",
              }}
            >
              {[
                { label: "Video Title", value: streamData.streamTitle },
                { label: "Category", value: streamData.category || "-" },
                { label: "Tags", value: streamData.tags || "-" },
                { label: "Schedule", value: streamData.scheduleStart || "-" },
                { label: "Webcam Source", value: streamData.webcamSource || "-" },
                { label: "Waiting Screen", value: streamData.waitingScreen || "-" },
                { label: "Description", value: streamData.description || "-" },
              ].map((item, index) => (
                <div
                  key={index}
                  className="info-row mb-3"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <span
                    style={{
                      minWidth: "150px",
                      fontWeight: "600",
                      color: "#2B2A52",
                    }}
                  >
                    {item.label} :
                  </span>
                  <span style={{ flex: 1, color: "#444" }}>{item.value}</span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStreamingPage;
